import { useContact } from "../../stores/useContactStore"
import { useWebSocketChatContext } from "../../contexts/webSocketChatContext"
import { getProfileUserById } from "../../utils/utils"
import { useData } from "../../contexts/dataContext"

const ProfileNameByMessage = ({ message, platform, suffix = "" }) => {
    const { allUsersGroup } = useData()
    const { getContactByContactDataAndPlatform } = useWebSocketChatContext()
    let contact = useContact(message.contact_id) || {}

    const getUserProfileSender = (user_id) => {
        if (message?.bot_details?.is_bot) {
            return { name: message?.bot_details?.agent_name || "Agente de IA" }
        }
        let user = { name: "Você (Envio externo)" }
        if (user_id) {
            user = getProfileUserById(allUsersGroup, user_id)
        }
        return user
    }

    let name = ""

    if (message.direction === "send") {
        const user = getUserProfileSender(message.user_id)
        name = user?.name || ""
    } else {
        const contactData = getContactByContactDataAndPlatform(contact, platform)
        name = contactData?.name || ""
    }

    return name ? `${name}${suffix}` : null
}

export default ProfileNameByMessage
